import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTooltip } from '../../Tooltip/Tooltip';
import Typography from '@material-ui/core/Typography';
import HelpIcon from '@material-ui/icons/Help';

const useStyles = makeStyles((theme: any) => ({
  help: {
    color: theme.palette.lightBlack,
    marginLeft: 'auto',
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  tooltip: { padding: theme.spacing(0.5) },
}));

export default function StageDescription({ stage }) {
  const classes = useStyles();

  const description = stage?.description;

  return (
    <CustomTooltip
      title={
        <div className={classes.tooltip}>
          <Typography variant="subtitle1">{description}</Typography>
        </div>
      }
      arrow
      placement="top"
    >
      <HelpIcon className={classes.help} />
    </CustomTooltip>
  );
}
